<template>
	<div>
		<div class="search flex">
			<span class="tit">
				退款单管理
				<i class="el-icon-setting rule-setting" @click="ruleDrawer.show=true">退款规则管理</i>
			</span>
      <el-date-picker style="border-color: #567CFF"
                      v-model="search.dateRange"
                      type="daterange"
                      @change="skipPage(1)"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
      </el-date-picker>
			<el-input placeholder="退款单号/订单号"
								class="addART"
								v-model="search.keyword"
								suffix-icon="el-icon-search"
								size="small"
								@change="skipPage(1)">
			</el-input>
		</div>
		<div class="instrument">

      <div style="text-align: right;color: #FC7C66">
        <span style="display: inline-block;width: 280px">申请人数: {{statistics.applyNum}} 人</span>
        <span style="display: inline-block;width: 280px">支付总金额: {{statistics.payFee/100}} 元</span>
        <span style="display: inline-block;width: 280px">退款总金额: {{statistics.refundFee/100}} 元</span>
        <span style="display: inline-block;width: 280px">平台退款总金额: {{statistics.platformRefundFee/100}} 元</span>
      </div>

			<el-table
					:data="page.rows"
					class="record-table"
					:header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
					height="calc(100vh - 292px)"
					style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
					max-height="calc(100vh - 292px)">
				<el-table-column prop="refundNo" label="退款单号" align="center" width="150"></el-table-column>
				<el-table-column prop="orderNo" label="订单号" align="center" width="150">
					<template slot-scope="scope">
						<a href="javascript:void(0)" style="color: cornflowerblue" @click="orderDetails(scope.row)">{{scope.row.orderNo}}</a>
					</template>
				</el-table-column>
				<el-table-column prop="billTimestamp" align="center" label="申请时间" width="140">
					<template slot-scope="scope">{{new Date(scope.row.applyTimestamp).Format('yyyy-MM-dd HH:mm')}}</template>
				</el-table-column>
        <el-table-column prop="refundReason" label="退款原因" align="center"></el-table-column>
				<el-table-column label="退款类型" align="center" width="100">
					<template slot-scope="scope">{{BILL_TYPES[scope.row.orderType]}}</template>
				</el-table-column>
				<el-table-column label="退款状态" align="center" width="100">
					<template slot-scope="scope">
            <span :state="scope.row.refundStatus">{{BILL_STATUS[scope.row.refundStatus]}}</span>
          </template>
				</el-table-column>
				<el-table-column label="支付金额" align="center" width="120">
					<template slot-scope="scope">
						<span>{{(scope.row.payFee/100).toFixed(2)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="已退金额" align="center" width="120">
					<template slot-scope="scope">
						<span>{{(scope.row.refundFee/100).toFixed(2)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="160">
					<template slot-scope="scope">
						<el-button v-if="scope.row.refundStatus==0" size="mini" type="text" class="btn" @click="openRefundDialog(scope.row)">审核</el-button>
						<el-button size="mini" type="text" class="btn" @click="billDetails(scope.row)">详情</el-button>
					</template>
				</el-table-column>

			</el-table>
			<el-pagination
					:hide-on-single-page="true"
					class="pagination"
					background
					prev-text="Prev"
					next-text="Next"
					@current-change="skipPage"
					:current-page="page.current"
					:page-size="page.size"
					layout="prev, pager, next"
					:total="page.total">
			</el-pagination>
		</div>

		<!-- 退款规则 -->
		<el-drawer title="退款规则管理" size="800px" class="drawerCommon"
							 :wrapperClosable="false"
							 :show-close="false"
							 @opened="handleRuleDrawerOpened"
							 :visible.sync="ruleDrawer.show">
			<el-table ref="refundRuleTable"
								:header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
								height="calc(100vh - 180px)" class="record-table"
								max-height="calc(100vh - 180px)"
								:data="ruleDrawer.rules">
				<el-table-column label="规则名称" prop="ruleTitle" align="center"></el-table-column>
				<el-table-column label="状态" align="center" width="60">
					<template slot-scope="scope">
						<span :state="scope.row.ruleStatus" @click="changeRuleStatus(scope.row)">{{scope.row.ruleStatus==0?'关闭':(scope.row.ruleStatus==1?'开启':'-')}}</span>
					</template>
				</el-table-column>
				<el-table-column label="退款比例" align="center" width="80">
					<template slot-scope="scope">{{scope.row.refundRate}}%</template>
				</el-table-column>
        <el-table-column label="退款说明" prop="refundExplain"></el-table-column>
				<el-table-column label="备注" prop="remark" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="80">
					<template slot-scope="scope">
						<el-button size="mini" type="text" class="btn" @click="delRefundRule(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>

			</el-table>
			<div class="footer">
				<el-button style="width: 90px;" size="small" type="primary" @click="openAddRuleDialog">新增规则</el-button>
				<el-button style="width: 90px;margin-left: 20px" size="small" @click="ruleDrawer.show=false">取消</el-button>
			</div>
		</el-drawer>

		<!-- 新增结算规则弹窗 -->
		<el-dialog :visible="addRuleDialog.show"
							 title="新增退款规则"
							 width="600px"
							 append-to-body
							 :show-close="false">
			<div style="padding-right: 80px">
				<el-form ref="addRuleForm" :model="addRuleDialog.form" label-width="90px">
					<el-form-item label="规则名称">
						<el-input v-model="addRuleDialog.form.ruleTitle" minlength="2" maxlength="30" show-word-limit></el-input>
					</el-form-item>
          <el-form-item label="退款类型">

            <el-radio-group v-model="addRuleDialog.form.refundType">
              <el-radio :label="1">预约</el-radio>
              <el-radio :label="2">月卡</el-radio>
              <el-radio :label="3">年卡</el-radio>
              <el-radio :label="4">测试</el-radio>
              <el-radio :label="5">其他</el-radio>
            </el-radio-group>
          </el-form-item>
					<el-form-item label="状态">
						<el-radio-group v-model="addRuleDialog.form.ruleStatus">
							<el-radio :label="1">启用</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="退款比例">
						<el-slider v-model="addRuleDialog.form.refundRate" :min="1" :max="100" style="width: 80%;display: inline-block;"></el-slider>
						<span class="slider-tips">{{addRuleDialog.form.refundRate}}%</span>
					</el-form-item>
          <el-form-item label="退款说明">
            <el-input type="textarea" :rows="4" v-model="addRuleDialog.form.refundExplain" maxlength="1000" show-word-limit></el-input>
          </el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" :rows="2" v-model="addRuleDialog.form.remark" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doAddRefundRule" :loading="addRuleDialog.btnLoad">新增</el-button>
				<el-button @click="addRuleDialog.show=false">取消</el-button>
			</div>
		</el-dialog>


    <el-dialog ref="doRefundDialog"
               title="退款规则"
               top="0"
               :close-on-click-modal="false"
               :show-close="false"
               :visible.sync="doRefundDialog.show">
      <el-form label-width="120px" label-suffix="：" v-model="doRefundDialog.item" style="width: 90%;">
        <el-form-item label="退款结果">
          <el-radio-group v-model="doRefundDialog.form.refundStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="规则" v-if="doRefundDialog.form.refundStatus==1">
          <el-radio-group  v-model="doRefundDialog.form.refundRuleId" @change="calcRefundFee">
            <el-radio v-for="rule in doRefundDialog.rules" :label="rule.id" :key="rule.id">
              {{rule.ruleTitle}}
              <el-tooltip :content="rule.refundExplain">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款金额" v-if="doRefundDialog.form.refundStatus==1">
          <p>{{doRefundDialog.form.refundFee}} 元</p>
        </el-form-item>
        <el-form-item :label="doRefundDialog.form.refundStatus==1?'说明':'拒绝原因'">
          <el-input type="textarea" v-model="doRefundDialog.form.refundRemark" :rows="4" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="doRefundDialog.form.remark" placeholder="仅后台可见" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doRefund" :loading="doRefundDialog.btnLoad">{{doRefundDialog.form.refundStatus==1?'退款':'拒绝'}}</el-button>
        <el-button @click="doRefundDialog.show=false">取消</el-button>
      </div>
    </el-dialog>


    <!--   退费详情    -->
    <el-dialog title="退款详情"
               top="0"
               :visible.sync="refundDetailsDialog.show">
      <div class="refund-details">
        <p><span>退款单号:</span>{{refundDetailsDialog.item.refundNo}}</p>
        <p><span>退款类型:</span>{{BILL_TYPES[refundDetailsDialog.item.orderType]}}</p>
        <p><span>订单号:</span>{{refundDetailsDialog.item.orderNo}}</p>
        <p><span>申请时间:</span>{{new Date(refundDetailsDialog.item.applyTimestamp).Format('yyyy-MM-dd HH:mm:ss')}}</p>
        <p><span>申请原因:</span>{{refundDetailsDialog.item.refundReason}}</p>
        <p><span>支付金额:</span>{{refundDetailsDialog.item.payFee/100}}</p>
        <p><span>退费金额:</span>{{refundDetailsDialog.item.refundFee/100}}</p>
        <p><span>审核状态:</span>{{BILL_STATUS[refundDetailsDialog.item.refundStatus]}}</p>
        <p><span>说明:</span>{{refundDetailsDialog.item.refundRemark}}</p>
        <p><span>备注:</span>{{refundDetailsDialog.item.remark}}</p>
      </div>
    </el-dialog>


	</div>
</template>

<script>
import base from "../../../api/common";
export default {
	name: "refundBillList",
	data() {
		return {
      BILL_TYPES:['-','预约单','月卡','年卡','测试单','其他'],
      BILL_STATUS:['未退款','已退款','已拒绝'],

      refundRuleTypeMap: new Map(),
      refundRuleMap: new Map(),
			search:{
				keyword:'',
        dateRange:[]
			},
			page:{
			  current: 1,
				size: 10,
				total: 8,
				rows:[]
			},
			ruleDrawer:{ // 规则drawer
        show: false,
				rules:[],
			},
      addRuleDialog:{ // 新增规则dialog
        show: false,
				btnLoad: false,
				form:{
          ruleTitle: '',
          refundType: 1,
          ruleStatus: 1,
					refundRate: 80,
          refundExplain: '',
					remark: ''
				}
			},
      doRefundDialog: {
        show: false,
        btnLoad: false,
        item: {},
        rules: [],
        form: {
          refundRuleId: 0,
          refundStatus: 1,
          refundFee: 0,
          refundRemark: '',
        }
      },
      refundDetailsDialog:{
        show: false,
        item: {}
      },
      statistics: {
        applyNum: 0,
        refundFee: 0,
        payFee: 0,
        platformRefundFee: 0,
      }

		}
	},
  inject: ['reload'],
	mounted() {
	  // 加载结算规则
		this.$ajax.post(base.basePath + 'financial/refund-rule/admin/list/in-use').then(res=>{
		  if(res.data.status === 'success'){
        $(res.data.list).each((i,o)=>{
          //1. id --> {rule}
          this.refundRuleMap.set(o.id,o);
          //2. type --> [rule]
          if(this.refundRuleTypeMap.get(o.refundType)){
            this.refundRuleTypeMap.get(o.refundType).push(o);
          }else{
            this.refundRuleTypeMap.set(o.refundType,[o]);
          }
        })
			}else{
		    this.$message.error('退款规则加载失败!');
			}
		}).catch(err=>{
		  console.error(err);
      this.$message.error('退款规则加载失败!');
		});

    // 默认时间跨度为当月
    let todayTimestamp = new Date();
    let monthFirstDay = new Date().setDate(1);
    this.search.dateRange.push(monthFirstDay,todayTimestamp)
	  this.skipPage(1);
	},
	methods: {
		getData(){
			let that = this;
      let params = {
        page: that.page.current,
        size: that.page.size,
        keyword: that.search.keyword,
      };
      if(that.search.dateRange.length === 2){
        params.beginTimestamp = new Date(that.search.dateRange[0]).getTime();
        params.endTimestamp = new Date(that.search.dateRange[1]).setHours(23,59,59,999);
      }
      that.$ajax.post(base.basePath + 'financial/refund-bill/admin/page', params).then(res=>{
			  if(res.data.status === 'success'){
			    that.page.current = res.data.current;
			    that.page.size = res.data.size;
			    that.page.total = res.data.total;
			    that.page.rows = res.data.rows;
				}else{
			    that.$message.error(res.data.message);
				}
			}).catch(err=>{
			  console.error(err);
			  that.$message.error('数据加载失败')
			})
		},
		skipPage(current){
		  let that = this;
 			this.page.current = current;
 			this.getData();
 			if(current != 1){return;}

      // 统计金额数据
      let params = {
        page: that.page.current,
        size: that.page.size,
        keyword: that.search.keyword,
      };
      if(that.search.dateRange.length === 2){
        params.beginTimestamp = new Date(that.search.dateRange[0]).getTime();
        params.endTimestamp = new Date(that.search.dateRange[1]).setHours(23,59,59,999);
      }

      this.$ajax.post(base.basePath + 'financial/refund-bill/admin/statistics', params).then(res=>{
        if(res.data.status === 'success'){
          that.statistics.applyNum = res.data.data.applyNum;
          that.statistics.refundFee = res.data.data.refundFee;
          that.statistics.payFee = res.data.data.payFee;
          that.statistics.platformRefundFee = res.data.data.platformRefundFee;
        }
      }).catch(err=>{
        console.error(err);
        that.$message.error('');
      });

		},
    billDetails(item){
      if(item){
        this.refundDetailsDialog.item = item;
        this.refundDetailsDialog.show = true;
      }
		},
    orderDetails(item){
		  console.log(item);
		},
    openSettlementDialog(){ // 新增结算
			let that = this;
			if(that.settlementItemDrawer.settlement.billStatus == 2){
			  that.$message.warning('账单已结清, 无需结算.');
          return;
      }

			that.settlementItemDialog.show = true;
			// 重置数据
      that.settlementItemDialog.form.ruleId = '';
      that.settlementItemDialog.form.settleAmount = 0;
      that.settlementItemDialog.form.voucher = '';
      that.settlementItemDialog.form.checkName = true;
      that.settlementItemDialog.form.doctorRealName ='';
      that.settlementItemDialog.form.remark = '';
		},
    handleRuleDrawerOpened(){
		  this.ruleDrawer.rules.length = 0;
			this.$ajax.post(base.basePath + 'financial/refund-rule/admin/list/all').then(res=>{
			  if(res.data.status === 'success'){
          this.ruleDrawer.rules = res.data.list;
				}else{
			    this.$message.error(res.data.message);
				}
			}).catch(err=>{
			  console.error(err);
			  this.$message.error('结算规则数据加载失败');
			})
    },
    openAddRuleDialog(){
		  this.addRuleDialog.show = true;
		  this.addRuleDialog.form.ruleTitle = '';
		  this.addRuleDialog.form.ruleStatus = 1;
		  this.addRuleDialog.form.refundRate = 80;
		  this.addRuleDialog.form.remark = '';
		},
    doAddRefundRule(){
		  let that = this;
		  if($.trim(that.addRuleDialog.form.ruleTitle).length == 0){that.$message.warning('规则名称不能为空'); return;}
		  that.addRuleDialog.btnLoad = true;
		  that.$ajax.post(base.basePath + 'financial/refund-rule/admin/add',that.addRuleDialog.form).then(res=>{
		    if(res.data.status === 'success'){
		      that.$message.success('新增成功');
		      setTimeout(()=>{that.reload()},1666);
				}else{
		      that.$message.error(res.data.message);
          that.addRuleDialog.btnLoad = false;
				}
			}).catch(err=>{
			  console.error(err);
			  that.$message.error('操作失败');
        that.addRuleDialog.btnLoad = false;
			})
		},
    changeRuleStatus(item){
		  let that = this;
      let targetStatus = (item.ruleStatus + 1)%2;
		  that.$messageBox.confirm('确定要' + (item.ruleStatus == 1?'关闭':'开启') + '吗?','状态更改确认', {type:'warning'}).then(()=>{
          that.$ajax.post(base.basePath + 'financial/refund-rule/admin/update/status/' + targetStatus +  '/' + item.id).then(res=>{
            if(res.data.status === 'success'){
              item.ruleStatus = targetStatus;
              that.$message.success('修改成功');
            }else{
              that.$message.error(res.data.message);
            }
          }).catch(err=>{
            console.error(err);
            that.$message.error('操作失败');
          })
      })
		},
    delRefundRule(id){
		  let that = this;
		  that.$messageBox.confirm('确定要删除此条规则吗?','删除确认',{type: 'warning'}).then(()=>{
		    that.$ajax.post(base.basePath + 'financial/refund-rule/admin/del/'+id).then(res=>{
		      if(res.data.status === 'success'){
		        $(that.ruleDrawer.rules).each((i,o)=>{
		          if(o.id == id){
		            that.ruleDrawer.rules.splice(i,1);
		            return false;
							}
						})
            that.$message.success('删除成功');
					}else{
		        that.$message.error(res.data.message);
					}
				}).catch(err=>{
				  console.error(err);
				  that.$message.error('删除失败');
				})
			})
		},
    openRefundDialog(item){
      if(this.refundRuleTypeMap.size===0){
        this.$message.error('退款规则加载失败');
        return;
      }
      let rules = this.refundRuleTypeMap.get(item.orderType);
      if(!rules){
        this.$message.warning('无可用退款规则');
        return;
      }
      this.doRefundDialog.item = item;
      this.doRefundDialog.rules = rules;
      this.doRefundDialog.show = true;
      this.doRefundDialog.form.refundFee = 0;
      this.doRefundDialog.form.refundRuleId = 0;
    },
    calcRefundFee(ruleId){
      let rule = this.refundRuleMap.get(ruleId);
      if(rule){
        this.doRefundDialog.form.refundFee = (this.doRefundDialog.item.payFee * rule.refundRate/100)/100;
      }
    },
    doRefund(){
		  let item = this.doRefundDialog.item;
		  let form = this.doRefundDialog.form;
      if(!item.id){return;}
		  if(form.refundStatus != 1 && form.refundStatus != 2){ this.$message.error('请选择退款结果'); return; }
      if(form.refundStatus == 1 && !form.refundRuleId){ this.$message.error('请选择退款规则!');return;}
      if(form.refundStatus == 2 && !form.refundRemark){this.$message.error('请填写拒绝原因!'); return;}
      if(form.refundFee<0.01){
        this.$message.error('退款金额不能低于1分');return;
      }

		  let params = {
		    refundStatus: form.refundStatus,
        refundRuleId: form.refundRuleId,
        refundRemark: form.refundRemark,
        remark: form.remark,
      };

      this.doRefundDialog.btnLoad = true;
      this.$ajax.post(base.basePath + 'financial/refund-bill/admin/refund/' + item.id, params).then(res=>{
		    this.doRefundDialog.btnLoad = false;
		    if(res.data.status === 'success'){
		      this.$message.success('操作成功');
          setTimeout(()=>{
            this.reload();
          },1666);
        }else{
		      this.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        this.$message.error('操作失败');
        this.doRefundDialog.btnLoad = false;

      })
    },
	}
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';
.btn{margin: 0;padding: 0 6px}
.el-icon-setting.rule-setting{
	font-size: 14px;
	font-weight: 900;
	color: #FC7C66;
	cursor: pointer;
	margin-left: 10px;
}
.dialog-footer{
	button{
		padding: 0 20px;
		height: 32px;
		line-height: 32px;
	}
}
.slider-tips{
	width: 10%;
	display: inline-block;
	line-height: 40px;
	height: 40px;
	vertical-align: top;
	margin-left: 20px;
}
span[state]{
	height: 24px;
	line-height: 24px;
	display: inline-block;
	padding: 0 6px;
	cursor: pointer;
}
span[state='1']{background: rgba(28, 162, 22, 0.1); color: #1CA116;}
span[state='2']{color: #FC7C66; background: #FFF2EF;}

div.refund-details{
  p{
    line-height: 1.4rem;
    span{
      display: inline-block;
      width: 90px;
      font-size: 16px;
      font-weight: 700;
    }
  }

}
</style>